import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
	selector: 'app-select-field',
	templateUrl: './select-field.component.html',
	styleUrls: ['./select-field.component.scss'],
})
export class SelectFieldComponent implements OnInit {
	@HostBinding('class') class = 'select-field';
	@Input() control: UntypedFormControl;
	@Input() options: any[];
	@Input() icon: string = null;
	@Input() label = '';
	@Input() name = '';

	constructor() {}

	ngOnInit(): void {}
}
